'use client';

import { c as _c } from "react/compiler-runtime";
import type { Provider } from '@repo/api-gw-sdk';
import { ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useEnvironment } from '@/contexts/useEnvironment';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { ResourceTypes } from './resourceTypes';
export const useSupportedResourceTypes = t0 => {
  const $ = _c(15);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cloudProviders = t1;
  const {
    isDemo,
    isDev
  } = useEnvironment();
  const {
    AzureSqlDatabaseSupport,
    AzureSqlDiscovery,
    AzureSqlManagedInstanceSupport,
    MySqlFlexibleServerSupport,
    SapHanaPitrSupport,
    AwsKeyspacesSupport,
    CassandraSupport,
    GoogleWorkspaceSupport,
    Microsoft365Support,
    EntraIdSupport,
    AwsEksClusterBackupSupport
  } = useFeatureFlags();
  const isLocalEnv = isDemo || isDev;
  const t2 = AzureSqlDatabaseSupport || AzureSqlDiscovery;
  let t3;
  if ($[2] !== AwsEksClusterBackupSupport || $[3] !== AwsKeyspacesSupport || $[4] !== AzureSqlManagedInstanceSupport || $[5] !== CassandraSupport || $[6] !== EntraIdSupport || $[7] !== GoogleWorkspaceSupport || $[8] !== Microsoft365Support || $[9] !== MySqlFlexibleServerSupport || $[10] !== SapHanaPitrSupport || $[11] !== cloudProviders || $[12] !== isLocalEnv || $[13] !== t2) {
    const resourceTypeEnabled = {
      [ResourceType.AwsKeyspacesTable]: AwsKeyspacesSupport,
      [ResourceType.AwsCassandraCluster]: CassandraSupport,
      [ResourceType.GcpCassandraCluster]: CassandraSupport,
      [ResourceType.AzureCassandraCluster]: CassandraSupport,
      [ResourceType.AwsEksCluster]: AwsEksClusterBackupSupport,
      [ResourceType.AzureSapHanaVm]: SapHanaPitrSupport,
      [ResourceType.GcpSapHanaVm]: SapHanaPitrSupport,
      [ResourceType.AzureSqlDatabase]: t2,
      [ResourceType.AzureSqlManagedInstance]: AzureSqlManagedInstanceSupport,
      [ResourceType.AzureMysql]: MySqlFlexibleServerSupport,
      [ResourceType.GoogleWorkspaceResource]: GoogleWorkspaceSupport,
      [ResourceType.Microsoft365Resource]: Microsoft365Support,
      [ResourceType.AzureEntraIdResource]: EntraIdSupport,
      [ResourceType.AzureDisk]: false,
      [ResourceType.AzureCosmosdbMongodb]: false,
      [ResourceType.AzureCosmosdbNosql]: false,
      [ResourceType.AzureAksNamespace]: false,
      [ResourceType.GcpGkeNamespace]: false,
      [ResourceType.GcpCloudFirestore]: false
    };
    t3 = Object.values(ResourceType).filter(type => type !== ResourceType.ResourceTypeUnspecified && (cloudProviders.length ? cloudProviders.includes(ResourceTypes[type]?.provider) : true) && (isLocalEnv || (resourceTypeEnabled[type] ?? true)));
    $[2] = AwsEksClusterBackupSupport;
    $[3] = AwsKeyspacesSupport;
    $[4] = AzureSqlManagedInstanceSupport;
    $[5] = CassandraSupport;
    $[6] = EntraIdSupport;
    $[7] = GoogleWorkspaceSupport;
    $[8] = Microsoft365Support;
    $[9] = MySqlFlexibleServerSupport;
    $[10] = SapHanaPitrSupport;
    $[11] = cloudProviders;
    $[12] = isLocalEnv;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};